import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import CategoriesSection from "@/pages/home/components/CategoriesSection";
import AboutSection from "@/pages/home/components/AboutSection";
import GuidesSection from "@/pages/home/components/GuidesSection";
import CtaSection from "@/pages/home/components/CtaSection";
import FaqSection from "@/pages/home/components/FaqSection";
import JsonLd from "@/components/feature/JsonLd";
import { buildHomeSchema } from "@/lib/seo";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={buildHomeSchema()} />
      <Navbar />
      <main>
        <Hero />
        <CategoriesSection />
        <AboutSection />
        <GuidesSection />
        <CtaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}